
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryPackageDialog extends _Ext.DialogBase<SalaryPackageRow, any> {
        protected getFormKey() { return SalaryPackageForm.formKey; }
        protected getIdProperty() { return SalaryPackageRow.idProperty; }
        protected getLocalTextPrefix() { return SalaryPackageRow.localTextPrefix; }
        protected getNameProperty() { return SalaryPackageRow.nameProperty; }
        protected getService() { return SalaryPackageService.baseUrl; }
        protected getDeletePermission() { return SalaryPackageRow.deletePermission; }
        protected getInsertPermission() { return SalaryPackageRow.insertPermission; }
        protected getUpdatePermission() { return SalaryPackageRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new SalaryPackageForm(this.idPrefix);

    }
}